import React from "react";
import {
  Button,
  Paper,
  Popper,
  Stack,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import EmailInfoPopupRow from "./EmailInfoPopupRow";
import { InfoOutlined } from "@mui/icons-material";
import ConfirmationContainer from "../../helpers/ConfirmationContainer";

const StyledPaper = styled(Paper)`
  padding: 1em;
  margin: 1em;
  background-color: ${props => props.theme.palette.grey[300]};
`;

const EmailInfoPopup = ({
  emailObj,
  onEmailDeleted,
}) => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const handleDeleteConfirm = () => onEmailDeleted();

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;
  const placement = isXsScreen ? "bottom" : "right";

  return (
    <Stack
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <InfoOutlined
        fontSize="small"/>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement={placement}>
        <StyledPaper>
          <EmailInfoPopupRow label="Date added">
            <Typography variant="subtitle1">
              {emailObj.createDate}
            </Typography>
          </EmailInfoPopupRow>
          <EmailInfoPopupRow label="Validation">
            {emailObj.validationDate ? (
              <Typography variant="subtitle1">
                Validated on {emailObj.validationDate}
              </Typography>
            ) : (
              <Typography variant="subtitle1">
                Not validated
              </Typography>
            )}
          </EmailInfoPopupRow>
          {onEmailDeleted &&
            <Stack
              width="100%"
              alignItems="center"
              pt={1}
            >
              <ConfirmationContainer
                dialogTitle="Confirm Email Deletion"
                dialogMessage={`Are you sure that you want to delete this email: "${emailObj.email}"?`}
                onConfirmed={handleDeleteConfirm}
              >
                <Button
                  variant="contained"
                  color="error"
                >
                  Delete
                </Button>
              </ConfirmationContainer>
            </Stack>
          }
        </StyledPaper>
      </Popper>
    </Stack>
  );
};

export default EmailInfoPopup;
